var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view--filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5332 4.04604C13.8608 4.99331 14.8817 6.30882 15.4698 7.83C15.5095 7.93985 15.5095 8.06015 15.4698 8.17C14.8817 9.69118 13.8608 11.0067 12.5332 11.954C11.2056 12.9012 9.62953 13.4387 7.99979 13.5C6.37005 13.4387 4.79398 12.9012 3.46639 11.954C2.1388 11.0067 1.11787 9.69118 0.529787 8.17C0.490071 8.06015 0.490071 7.93985 0.529787 7.83C1.11787 6.30882 2.1388 4.99331 3.46639 4.04604C4.79398 3.09878 6.37005 2.56129 7.99979 2.5C9.62953 2.56129 11.2056 3.09878 12.5332 4.04604ZM6.19418 10.7023C6.72864 11.0594 7.357 11.25 7.99979 11.25C8.86133 11.2487 9.68722 10.9058 10.2964 10.2966C10.9056 9.68743 11.2485 8.86155 11.2498 8C11.2498 7.35721 11.0592 6.72886 10.7021 6.1944C10.3449 5.65994 9.83737 5.24338 9.24351 4.99739C8.64965 4.75141 7.99618 4.68705 7.36574 4.81245C6.73531 4.93785 6.15621 5.24738 5.70169 5.7019C5.24717 6.15642 4.93764 6.73552 4.81224 7.36596C4.68683 7.99639 4.75119 8.64986 4.99718 9.24372C5.24316 9.83758 5.65972 10.3452 6.19418 10.7023ZM9.99979 8C9.99979 9.10457 9.10436 10 7.99979 10C6.89522 10 5.99979 9.10457 5.99979 8C5.99979 6.89543 6.89522 6 7.99979 6C9.10436 6 9.99979 6.89543 9.99979 8Z",
    fill: "#450A0A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewFilled);
export default __webpack_public_path__ + "static/media/view-filled.9486c4cee930fecf4f72e2641a13f184.svg";
export { ForwardRef as ReactComponent };